import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.string.includes.js";
var render = function render() {
  var _vm$pricePosting$last;
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "content-centered large"
  }, [_c(VTabs, {
    attrs: {
      centered: ""
    },
    model: {
      value: _vm.tab,
      callback: function callback($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, [_c(VTab, {
    key: 1
  }, [_vm._v("Dashboard")]), _c(VTab, {
    key: 2
  }, [_vm._v("KPI")]), _c(VTab, {
    key: 3
  }, [_vm._v("Accounting Data")]), _vm.canManagePricePosting ? _c(VTab, {
    key: 4
  }, [_vm._v("Price posting")]) : _vm._e(), _vm.hasAccessToSuperAdminData ? _c(VTab, {
    key: 5
  }, [_vm._v("Documents")]) : _vm._e(), _vm.canManageWineryDashboards ? _c(VTab, {
    key: 6
  }, [_vm._v("Public dashboards")]) : _vm._e()], 1), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: [0, 1, 2].includes(_vm.tab),
      expression: "[0, 1, 2].includes(tab)"
    }],
    staticClass: "form-date-container"
  }, [_vm.tab === 2 ? _c("div", {
    staticClass: "list-actions-admin"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small secondary",
    attrs: {
      rounded: ""
    },
    on: {
      click: _vm.openPaymentSearchDialog
    }
  }, [_c(VIcon, {
    staticClass: "fas fa-search mr-1",
    attrs: {
      size: "1rem",
      dark: ""
    }
  }), _vm._v(" search payments ")], 1)], 1) : _vm._e(), _c("div", {
    staticClass: "text-smaller text-italic"
  }, [_vm._v("From date is included, to date is not included")]), _c("div", {
    staticClass: "form-date-line-search"
  }, [_c("div", {
    staticClass: "form-date-line-search-dates"
  }, [_c("div", [_c("span", [_vm._v("From")]), _c("date-picker", {
    attrs: {
      clearable: false,
      valueType: "format"
    },
    model: {
      value: _vm.formSearch.dateStart,
      callback: function callback($$v) {
        _vm.$set(_vm.formSearch, "dateStart", $$v);
      },
      expression: "formSearch.dateStart"
    }
  })], 1), _c("div", [_c("span", [_vm._v("to")]), _c("date-picker", {
    attrs: {
      clearable: false,
      valueType: "format"
    },
    model: {
      value: _vm.formSearch.dateEnd,
      callback: function callback($$v) {
        _vm.$set(_vm.formSearch, "dateEnd", $$v);
      },
      expression: "formSearch.dateEnd"
    }
  })], 1)])])]), _c(VTabsItems, {
    model: {
      value: _vm.tab,
      callback: function callback($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, [_c(VTabItem, {
    key: 1
  }, [_c("div", {
    staticClass: "mt-4"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: true,
      loading: _vm.isGeneratingDashboard
    },
    on: {
      click: function click($event) {
        return _vm.searchIndicators();
      }
    }
  }, [_vm._v(" Generate dashboard ")])], 1), _vm.isGeneratingDashboard ? _c("div", {
    staticClass: "mt-4 text-smaller text-italic"
  }, [_vm._v(" It may take a while, please wait a moment ")]) : _vm._e(), _vm.loaded && _vm.nb_orders_made < 1 ? _c("div", {
    staticClass: "mt-4"
  }, [_vm._v(" No sales available for this period. ")]) : _vm._e(), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showIndicators,
      expression: "showIndicators"
    }],
    staticClass: "indicators-global-container"
  }, [_c("div", {
    staticClass: "indicators-mains"
  }, [_c("div", {
    staticClass: "indicators-mains-item"
  }, [_c("i", {
    staticClass: "fas fa-shopping-cart"
  }), _c("div", {
    staticClass: "indicators-mains-item-title"
  }, [_vm._v("Orders made")]), _c("div", {
    staticClass: "indicators-mains-item-datas"
  }, [_c("div", {
    staticClass: "indicators-mains-item-datas-main"
  }, [_vm._v(" " + _vm._s(_vm.nb_orders_made) + " ")])])]), _c("div", {
    staticClass: "indicators-mains-item"
  }, [_c("i", {
    staticClass: "fas fa-hand-holding-usd"
  }), _c("div", {
    staticClass: "indicators-mains-item-title"
  }, [_vm._v("Turnover")]), _c("div", {
    staticClass: "indicators-mains-item-datas"
  }, [_c("div", {
    staticClass: "indicators-mains-item-datas-main"
  }, [_vm._v(_vm._s(_vm.formatPrice(_vm.turnover)) + " €")]), _c("div", {
    staticClass: "indicators-mains-item-datas-secondary"
  }, [_vm._v(" Av. cart : " + _vm._s(_vm.formatPrice(_vm.turnover / _vm.nb_orders_made)) + " € ")])])]), _c("div", {
    staticClass: "indicators-mains-item"
  }, [_c("i", {
    staticClass: "fas fa-wine-bottle"
  }), _c("div", {
    staticClass: "indicators-mains-item-title"
  }, [_vm._v("Bottles ordered")]), _c("div", {
    staticClass: "indicators-mains-item-datas"
  }, [_c("div", {
    staticClass: "indicators-mains-item-datas-main"
  }, [_vm._v(_vm._s(_vm.nb_btl_orders))]), _c("div", {
    staticClass: "indicators-mains-item-datas-secondary"
  }, [_vm._v(" Av. order : " + _vm._s((_vm.nb_btl_orders / _vm.nb_orders_made).toFixed()) + " bottles ")])])])]), _c("div", {
    staticClass: "indicators-charts"
  }, [_c("div", {
    staticClass: "indicators-charts-item",
    class: {
      loaded: _vm.loaded
    }
  }, [_c("div", {
    staticClass: "indicators-charts-item-title"
  }, [_vm._v("Product by types")]), _c("div", {
    ref: "wineType",
    staticClass: "indicators-charts-item-chart"
  })]), _c("div", {
    staticClass: "indicators-charts-item",
    class: {
      loaded: _vm.loaded
    }
  }, [_c("div", {
    staticClass: "indicators-charts-item-title"
  }, [_vm._v("Orders destination")]), _c("div", {
    ref: "destination",
    staticClass: "indicators-charts-item-chart"
  })]), _vm.$whitelabel.isMultipleWineries ? [_c("div", {
    staticClass: "indicators-charts-item",
    class: {
      loaded: _vm.loaded
    }
  }, [_c("div", {
    staticClass: "indicators-charts-item-title"
  }, [_vm._v("Orders by producers")]), _c("div", {
    ref: "producers",
    staticClass: "indicators-charts-item-chart"
  })]), _c("div", {
    staticClass: "indicators-charts-item",
    class: {
      loaded: _vm.loaded
    }
  }, [_c("div", {
    staticClass: "indicators-charts-item-title"
  }, [_vm._v("Turnover by producers")]), _c("div", {
    ref: "turnoverWineries",
    staticClass: "indicators-charts-item-chart"
  })])] : _vm._e()], 2), _c("div", {
    staticClass: "indicators-bigcharts"
  }, [_c("div", {
    staticClass: "indicators-bigcharts-item",
    class: {
      loaded: _vm.loaded
    }
  }, [_c("div", {
    staticClass: "indicators-bigcharts-item-title"
  }, [_vm._v("Types of users making orders")]), _c("div", {
    ref: "userTypes",
    staticClass: "indicators-bigcharts-item-chart"
  })]), _c("div", {
    staticClass: "indicators-bigcharts-item",
    class: {
      loaded: _vm.loaded
    }
  }, [_c("div", {
    staticClass: "indicators-bigcharts-item-title"
  }, [_vm._v("Destinations by user types")]), _c("div", {
    ref: "destinationByUserTypes",
    staticClass: "indicators-bigcharts-item-chart"
  })]), _c("div", {
    staticClass: "indicators-bigcharts-item",
    class: {
      loaded: _vm.loaded
    }
  }, [_c("div", {
    staticClass: "indicators-bigcharts-item-title"
  }, [_vm._v("Quantity sold by reference")]), _c("div", {
    ref: "references",
    staticClass: "indicators-bigcharts-item-chart"
  })])])])]), _c(VTabItem, {
    key: 2
  }, [_c("div", {
    staticClass: "export-kpi-global-container container-centered small-2"
  }, [_c("div", {
    staticClass: "export-kpi-form pb-1"
  }, [_c(VAutocomplete, {
    attrs: {
      items: _vm.kpiExportTypesAllowed,
      "item-text": "text",
      "item-value": "value",
      solo: "",
      "hide-no-data": "",
      "hide-selected": ""
    },
    model: {
      value: _vm.kpiSearch.type,
      callback: function callback($$v) {
        _vm.$set(_vm.kpiSearch, "type", $$v);
      },
      expression: "kpiSearch.type"
    }
  }), _c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: true,
      loading: _vm.isExportingKpi
    },
    on: {
      click: function click($event) {
        return _vm.exportKpi();
      }
    }
  }, [_vm._v(" Export ")])], 1), _vm.isExportingKpi ? _c("div", {
    staticClass: "mt-4 text-smaller text-italic"
  }, [_vm._v(" It may take a while, please wait a moment ")]) : _vm._e()])]), _c(VTabItem, {
    key: 3
  }, [_c("div", {
    staticClass: "export-kpi-global-container search-global-container container-centered small-2"
  }, [_c("div", {
    staticClass: "export-kpi-form pb-1"
  }, [_c(VAutocomplete, {
    attrs: {
      items: _vm.dataExportTypesAllowed,
      "item-text": "text",
      "item-value": "value",
      solo: "",
      "hide-no-data": "",
      "hide-selected": "",
      "hide-details": "auto",
      disabled: _vm.isExportingData
    },
    model: {
      value: _vm.dataSearch.type,
      callback: function callback($$v) {
        _vm.$set(_vm.dataSearch, "type", $$v);
      },
      expression: "dataSearch.type"
    }
  }), _vm.dataSearch.type !== _vm.dataExportTypes.CONSULTANT_COMMISSIONS.value ? [_c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: true,
      loading: _vm.isExportingData
    },
    on: {
      click: function click($event) {
        return _vm.exportData();
      }
    }
  }, [_vm._v(" Export ")])] : _vm._e()], 2), _vm.dataSearch.type === _vm.dataExportTypes.CONSULTANT_COMMISSIONS.value ? _c("div", {
    staticClass: "export-kpi-form pt-2"
  }, [_c(VAutocomplete, {
    attrs: {
      items: _vm.consultants,
      "hide-no-data": "",
      "hide-selected": "",
      multiple: "",
      chips: "",
      "deletable-chips": "",
      solo: "",
      "item-text": "fullname",
      "item-value": "id_user",
      label: "Consultants (optional)",
      color: "white",
      clearable: ""
    },
    model: {
      value: _vm.dataSearch.consultantIds,
      callback: function callback($$v) {
        _vm.$set(_vm.dataSearch, "consultantIds", $$v);
      },
      expression: "dataSearch.consultantIds"
    }
  }), _c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: true,
      loading: _vm.isExportingData
    },
    on: {
      click: function click($event) {
        return _vm.exportData();
      }
    }
  }, [_vm._v(" Export ")])], 1) : _vm._e(), _vm.isExportingData ? _c("div", {
    staticClass: "mt-4 text-smaller text-italic"
  }, [_vm._v(" It may take a while, please wait a moment ")]) : _vm._e()])]), _vm.canManagePricePosting ? _c(VTabItem, {
    key: 4
  }, [_c("div", [_c("div", {
    staticClass: "container-centered small-2 mt-default"
  }, [_c("div", {
    staticClass: "text-center text-bold"
  }, [_vm._v(" Create/Update price posting for application date. "), _c("br"), _c("div", {
    staticClass: "text-smaller"
  }, [_vm._v(" Automatically applicable to the horeca US in New-York, New-Jersey and Connecticut "), _c("br"), _vm._v(" and US Corporates and their users, except those in Pennsylvania ")])]), _c("div", {
    staticClass: "mt-small-2"
  }, [_c(VMenu, {
    attrs: {
      "close-on-content-click": false,
      transition: "scale-transition",
      width: "100px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c(VTextField, _vm._g(_vm._b({
          attrs: {
            label: "Application month",
            type: "dateMonth",
            required: "",
            "hide-details": "auto",
            disabled: _vm.pricePosting.isDataCreating
          },
          model: {
            value: _vm.pricePosting.form.applicationDate,
            callback: function callback($$v) {
              _vm.$set(_vm.pricePosting.form, "applicationDate", $$v);
            },
            expression: "pricePosting.form.applicationDate"
          }
        }, "v-text-field", attrs, false), on))];
      }
    }], null, false, 4244968151),
    model: {
      value: _vm.pricePosting.addDateMenu,
      callback: function callback($$v) {
        _vm.$set(_vm.pricePosting, "addDateMenu", $$v);
      },
      expression: "pricePosting.addDateMenu"
    }
  }, [_c(VDatePicker, {
    attrs: {
      min: _vm.pricePosting.minDate,
      type: "month",
      disabled: _vm.pricePosting.isDataCreating
    },
    on: {
      input: function input($event) {
        _vm.pricePosting.addDateMenu = false;
      }
    },
    model: {
      value: _vm.pricePosting.form.applicationDate,
      callback: function callback($$v) {
        _vm.$set(_vm.pricePosting.form, "applicationDate", $$v);
      },
      expression: "pricePosting.form.applicationDate"
    }
  })], 1), _c("div", {
    staticClass: "flex justify-center mt-3"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      loading: _vm.pricePosting.isDataCreating,
      disabled: _vm.pricePostingIsAnyActionInProgress,
      rounded: ""
    },
    on: {
      click: function click($event) {
        return _vm.pricePostingCreateConfirm();
      }
    }
  }, [_vm._v(" Generate prices ")]), _c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      loading: _vm.pricePosting.isDataDuplicating,
      disabled: _vm.pricePostingIsAnyActionInProgress,
      rounded: ""
    },
    on: {
      click: function click($event) {
        return _vm.pricePostingDuplicateFromPreviousMonthConfirm();
      }
    }
  }, [_vm._v(" Duplicate from previous month ")])], 1)], 1), _vm.pricePosting.isDataCreating ? _c("div", {
    staticClass: "text-center text-italic mt-small"
  }, [_c("p", [_vm._v("Generating price posting declaration file ...")]), _c("p", {
    staticClass: "text-smaller text-normal"
  }, [_vm._v("It may take a while, please wait a moment")])]) : _vm.pricePosting.lastErrorCreating ? _c("div", {
    staticClass: "text-cetner errorLabel mt-small"
  }, [_vm.pricePosting.lastErrorCreating.message ? [_c("div", {
    staticClass: "mb-1"
  }, [_vm._v(" " + _vm._s(_vm.pricePosting.lastErrorCreating.message) + " ")])] : _vm.pricePosting.lastErrorCreating.Message ? [_c("div", {
    staticClass: "mb-1"
  }, [_vm._v(" " + _vm._s(_vm.pricePosting.lastErrorCreating.Message) + " ")]), ((_vm$pricePosting$last = _vm.pricePosting.lastErrorCreating.InnerExceptions) === null || _vm$pricePosting$last === void 0 ? void 0 : _vm$pricePosting$last.length) > 0 ? _c("div", {
    staticClass: "text-smaller"
  }, _vm._l(_vm.pricePosting.lastErrorCreating.InnerExceptions, function (innerException, exIndex) {
    var _innerException$Messa;
    return _c("div", {
      key: "ppostExc" + exIndex
    }, [_vm._v(" " + _vm._s((_innerException$Messa = innerException.Message) !== null && _innerException$Messa !== void 0 ? _innerException$Messa : innerException.message) + " ")]);
  }), 0) : _vm._e()] : _vm._e()], 2) : _vm._e()]), _c("div", {
    staticClass: "pt-4 mt-default border-top-grey"
  }, [_c("div", {
    staticClass: "flex justify-end mb-2"
  }, [_c("i", {
    staticClass: "fas fa-sync cursor--pointer text-smaller mr-2",
    attrs: {
      disabled: _vm.pricePosting.isDataLoading
    },
    on: {
      click: function click($event) {
        return _vm.fetchPricePostings();
      }
    }
  })]), _vm.pricePosting.isDataLoading ? _c("div", {
    staticClass: "list-empty text-center text-italic"
  }, [_c("p", [_vm._v("Loading data ...")])]) : _vm.pricePosting.results.totalCount === 0 ? _c("div", {
    staticClass: "list-empty text-center text-italic"
  }, [_c("p", [_vm._v("No price posting has been created")])]) : _c("div", [_c(VDataTable, {
    staticClass: "cursor--pointer",
    attrs: {
      headers: _vm.pricePosting.results.headers,
      items: _vm.pricePosting.results.items,
      "items-per-page": +_vm.pricePosting.results.totalCount,
      "footer-props": {
        options: {
          itemsPerPage: -1
        }
      },
      "disable-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "item.applicationDate",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_vm._v(" " + _vm._s(_vm._f("formatDate_string")(item.applicationDate)) + " ")];
      }
    }, {
      key: "item.status",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [_c("div", {
          staticClass: "badge --small",
          class: Object.values(_vm.pricePosting.statusList).find(function (x) {
            return x.id == item.status;
          }).cssClass
        }, [_vm._v(" " + _vm._s(Object.values(_vm.pricePosting.statusList).find(function (x) {
          return x.id == item.status;
        }).text) + " ")])];
      }
    }, {
      key: "item.urlBatchFile",
      fn: function fn(_ref4) {
        var item = _ref4.item;
        return [_c("div", {
          staticClass: "d-flex"
        }, [item.urlBatchFile ? [_c(VBtn, {
          staticClass: "dfwa-btn --small-2 secondary",
          attrs: {
            disabled: _vm.pricePostingIsAnyActionInProgress,
            rounded: ""
          },
          on: {
            click: function click($event) {
              return _vm.pricePostingDownload(item);
            }
          }
        }, [_c("i", {
          staticClass: "fas fa-file-download mr-1"
        }), _vm._v(" NYSLA File ")])] : [_vm._v(_vm._s(_vm.emptyCellContent))], item.status == _vm.pricePosting.statusList.DRAFT.id || item.status == _vm.pricePosting.statusList.POSTED.id ? _c(VBtn, {
          staticClass: "dfwa-btn --small-2 secondary",
          attrs: {
            rounded: "",
            title: "Regenerate csv file",
            loading: _vm.pricePosting.regeneratingNysla.isPending,
            disabled: _vm.pricePostingIsAnyActionInProgress
          },
          on: {
            click: function click($event) {
              return _vm.confirmPricePostingRegenerateNyslaFile(item);
            }
          }
        }, [_c("i", {
          staticClass: "fas fa-sync cursor--pointer"
        })]) : _vm._e()], 2), item.batchFileLastGenerationDate ? _c("div", {
          staticClass: "text-smaller text-italic"
        }, [_vm._v(" " + _vm._s(_vm._f("formatDateTimeToLocal")(item.batchFileLastGenerationDate)) + " ")]) : _vm._e()];
      }
    }, {
      key: "item.urlHalPriceFile",
      fn: function fn(_ref5) {
        var item = _ref5.item;
        return [_c("div", {
          staticClass: "d-flex"
        }, [item.urlHalPriceFile ? [_c(VBtn, {
          staticClass: "dfwa-btn --small-2 secondary",
          attrs: {
            disabled: _vm.pricePostingIsAnyActionInProgress,
            rounded: ""
          },
          on: {
            click: function click($event) {
              return _vm.confirmPricePostingDownloadHalFile(item);
            }
          }
        }, [_c("i", {
          staticClass: "fas fa-file-download mr-1"
        }), _vm._v(" HAL File ")])] : [_vm._v(_vm._s(_vm.emptyCellContent))], item.status == _vm.pricePosting.statusList.DRAFT.id || item.status == _vm.pricePosting.statusList.POSTED.id ? _c(VBtn, {
          staticClass: "dfwa-btn --small-2 secondary",
          attrs: {
            rounded: "",
            title: "Regenerate csv file",
            loading: _vm.pricePosting.regeneratingHal.isPending,
            disabled: _vm.pricePostingIsAnyActionInProgress
          },
          on: {
            click: function click($event) {
              return _vm.confirmPricePostingRegenerateHalFile(item);
            }
          }
        }, [_c("i", {
          staticClass: "fas fa-sync cursor--pointer"
        })]) : _vm._e()], 2), item.halFileLastGenerationDate ? _c("div", {
          staticClass: "text-smaller text-italic"
        }, [_vm._v(" " + _vm._s(_vm._f("formatDateTimeToLocal")(item.halFileLastGenerationDate)) + " ")]) : _vm._e()];
      }
    }, {
      key: "item.expirationDate",
      fn: function fn(_ref6) {
        var item = _ref6.item;
        return [item.expirationDate ? _c("div", [_vm._v(" " + _vm._s(_vm._f("formatDate_string")(item.expirationDate)) + " ")]) : _c("div", [_vm._v(" " + _vm._s(_vm.emptyCellContent) + " ")])];
      }
    }, {
      key: "item.numberOfManualModifications",
      fn: function fn(_ref7) {
        var item = _ref7.item;
        return [item.numberOfManualModifications > 0 ? [_c("div", {
          staticClass: "flex justify-center"
        }, [_c("div", [_vm._v(_vm._s(item.numberOfManualModifications))]), _c("div", {
          staticClass: "ml-2"
        }, [_c(VBtn, {
          staticClass: "dfwa-btn --small-2 secondary",
          attrs: {
            rounded: ""
          },
          on: {
            click: function click($event) {
              return _vm.pricePostingDownloadModifications(item);
            }
          }
        }, [_c(VIcon, {
          staticClass: "fa fa-download px-1",
          attrs: {
            size: "0.65rem"
          }
        })], 1)], 1)]), _c("div", {
          staticClass: "text-smaller text-italic"
        }, [_vm._v(" Last : " + _vm._s(_vm._f("formatDateTime")(item.lastDateOfManualModifications)) + " ")])] : [_vm._v("-")]];
      }
    }, {
      key: "item.creation",
      fn: function fn(_ref8) {
        var item = _ref8.item;
        return [_vm._v(" " + _vm._s(_vm._f("formatDate_string")(item.creationDate)) + " " + _vm._s("(".concat(item.creator.firstName, " ").concat(item.creator.lastName, ")")) + " ")];
      }
    }, {
      key: "item.actions",
      fn: function fn(_ref9) {
        var item = _ref9.item;
        return [_c("div", {
          staticClass: "td-without-link",
          on: {
            click: function click($event) {
              $event.stopPropagation();
            }
          }
        }, [_vm.canManagePricePosting ? _c("div", {
          staticClass: "table-actions"
        }, [item.status === _vm.pricePosting.statusList.DRAFT.id ? _c("a", {
          attrs: {
            href: "#",
            disabled: item.isPosting || item.isDeleting
          },
          on: {
            click: function click($event) {
              return _vm.confirmPricePostingPosted(item);
            }
          }
        }, [_vm._v(" Posted ")]) : _vm._e(), [_vm.pricePosting.statusList.DRAFT.id, _vm.pricePosting.statusList.BATCH_CREATION_FAILED.id].includes(item.status) ? _c("a", {
          attrs: {
            href: "#",
            disabled: item.isPosting || item.isDeleting
          },
          on: {
            click: function click($event) {
              return _vm.confirmPricePostingCancelled(item);
            }
          }
        }, [_vm._v(" Cancel ")]) : _vm._e()]) : _c("div", [_vm._v(_vm._s(_vm.emptyCellContent))])])];
      }
    }], null, true)
  })], 1)])])]) : _vm._e(), _vm.hasAccessToSuperAdminData ? _c(VTabItem, {
    key: 5
  }, [_c("div", [_c("div", {
    staticClass: "mt-default"
  }, [_c("div", {
    staticClass: "container-centered small-2"
  }, [_c("div", {
    staticClass: "search-global-container"
  }, [_c("div", {
    staticClass: "search-main-line"
  }, [_c("div", {
    staticClass: "search-main-text-field"
  }, [_c(VTextField, {
    attrs: {
      solo: "",
      placeholder: "Search for a file",
      clearable: "",
      "hide-details": "auto",
      loading: _vm.documents.isDataLoading,
      "append-icon": "fa-search"
    },
    on: {
      blur: function blur($event) {
        _vm.documents.formSearch.labelSearch != _vm.documents.searchLabelLastUsed && _vm.documentsSearch();
      },
      "click:append": function clickAppend($event) {
        return _vm.documentsSearch();
      },
      keydown: function keydown($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.documentsSearch();
      },
      "click:clear": function clickClear() {
        _vm.documents.formSearch.labelSearch = null;
        _vm.documentsSearch();
      }
    },
    model: {
      value: _vm.documents.formSearch.labelSearch,
      callback: function callback($$v) {
        _vm.$set(_vm.documents.formSearch, "labelSearch", $$v);
      },
      expression: "documents.formSearch.labelSearch"
    }
  })], 1)]), _c("div", {
    staticClass: "search-table-top"
  }, [_c("div", {
    staticClass: "search-other-fields"
  }, [_c("div", {
    staticClass: "flex gap-2"
  }, [_c(VAutocomplete, {
    attrs: {
      items: _vm.documents.documentTypeCategoriesList,
      "item-value": "value",
      "item-text": "label",
      label: "All document types",
      "hide-details": "auto",
      clearable: "",
      solo: "",
      multiple: "",
      chips: "",
      "deletable-chips": ""
    },
    on: {
      blur: function blur($event) {
        _vm.documents.formSearch.documentTypeCategories != _vm.documents.searchCategoriesLastUsed && _vm.documentsSearch();
      }
    },
    model: {
      value: _vm.documents.formSearch.documentTypeCategories,
      callback: function callback($$v) {
        _vm.$set(_vm.documents.formSearch, "documentTypeCategories", $$v);
      },
      expression: "documents.formSearch.documentTypeCategories"
    }
  })], 1), _c("div", {
    staticClass: "--no-flex"
  }, [_c("div", {
    staticClass: "form-date-container mt-0"
  }, [_c("div", {
    staticClass: "text-smaller"
  }, [_c("strong", [_vm._v("File upload/creation date")]), _vm._v(" : From date is included, to date is not included ")]), _c("div", {
    staticClass: "form-date-line-search"
  }, [_c("div", {
    staticClass: "form-date-line-search-dates"
  }, [_c("div", [_c("span", [_vm._v("From")]), _c("date-picker", {
    attrs: {
      clearable: false,
      valueType: "format"
    },
    on: {
      change: function change($event) {
        return _vm.documentsSearch();
      }
    },
    model: {
      value: _vm.documents.formSearch.insertDateStart,
      callback: function callback($$v) {
        _vm.$set(_vm.documents.formSearch, "insertDateStart", $$v);
      },
      expression: "documents.formSearch.insertDateStart"
    }
  })], 1), _c("div", [_c("span", [_vm._v("to")]), _c("date-picker", {
    attrs: {
      clearable: false,
      valueType: "format"
    },
    on: {
      change: function change($event) {
        return _vm.documentsSearch();
      }
    },
    model: {
      value: _vm.documents.formSearch.insertDateEnd,
      callback: function callback($$v) {
        _vm.$set(_vm.documents.formSearch, "insertDateEnd", $$v);
      },
      expression: "documents.formSearch.insertDateEnd"
    }
  })], 1)])])])])])])])]), _c("div", [_vm.documents.isDataLoading ? _c("div", {
    staticClass: "list-empty text-center text-italic"
  }, [_c("p", [_vm._v("Loading data ...")]), _c("p", {
    staticClass: "text-smaller text-normal"
  }, [_vm._v("It may take a while, please wait a moment")])]) : _vm.documents.results.totalCount === null ? _c("div", {
    staticClass: "list-empty text-center text-italic"
  }, [_vm._v(" Please do a search to display the results table ")]) : _vm.documents.results.totalCount === 0 ? _c("div", {
    staticClass: "list-empty text-center text-italic"
  }, [_vm._v(" No file matchs these filters ")]) : _c(VDataTable, {
    staticClass: "cursor--pointer",
    attrs: {
      headers: _vm.documents.results.headers,
      items: _vm.documents.results.items,
      "items-per-page": +_vm.documents.results.totalCount,
      "footer-props": {
        options: {
          itemsPerPage: -1
        }
      },
      "disable-sort": ""
    },
    on: {
      "click:row": _vm.documentsRowClick
    },
    scopedSlots: _vm._u([{
      key: "item.type",
      fn: function fn(_ref10) {
        var item = _ref10.item;
        return [_c("div", {
          staticClass: "td-without-link --inline-actions --left",
          on: {
            click: function click($event) {
              $event.stopPropagation();
            }
          }
        }, [_c(VChip, {
          attrs: {
            label: ""
          }
        }, [_c(VIcon, {
          attrs: {
            left: "",
            small: ""
          }
        }, [_vm._v("mdi-sitemap")]), _vm._v(" " + _vm._s(Object.values(_vm.platformDocumentTypes).find(function (x) {
          return x.id === item.type;
        }).label) + " ")], 1)], 1)];
      }
    }, {
      key: "item.tag",
      fn: function fn(_ref11) {
        var item = _ref11.item;
        return [_c("div", {
          staticClass: "td-without-link --inline-actions --center",
          on: {
            click: function click($event) {
              $event.stopPropagation();
            }
          }
        }, [item.tag ? [_c(VChip, {
          attrs: {
            label: ""
          }
        }, [_c(VIcon, {
          attrs: {
            left: "",
            small: ""
          }
        }, [_vm._v("mdi-tag")]), _vm._v(" " + _vm._s(item.tag) + " ")], 1)] : _c("div", [_vm._v(" " + _vm._s(_vm.emptyCellContent) + " ")])], 2)];
      }
    }, {
      key: "item.relativeParentId",
      fn: function fn(_ref12) {
        var item = _ref12.item;
        return [item.relativeParentId ? _c("div", {
          staticClass: "td-without-link --inline-actions --center",
          on: {
            click: function click($event) {
              $event.stopPropagation();
            }
          }
        }, [_c("router-link", {
          staticClass: "router-link --underlined",
          attrs: {
            to: _vm.documentGoToRelated(item)
          }
        }, [[_vm.platformDocumentTypes.ORDERS_AUTO.id, _vm.platformDocumentTypes.ORDERS_ATTACHED.id, _vm.platformDocumentTypes.ORDERS_CONFIRMATION_AUTO.id, _vm.platformDocumentTypes.ORDERS_CONFIRMATION_ATTACHED.id].includes(item.type) ? [_vm._v(" Order #" + _vm._s(item.relativeParentId) + " ")] : [_vm.platformDocumentTypes.INBOUND_DELIVERIES_AUTO.id, _vm.platformDocumentTypes.INBOUND_DELIVERIES_ATTACHED.id].includes(item.type) ? [_vm._v(" Order dispatch #" + _vm._s(item.relativeParentId) + " ")] : [_vm.platformDocumentTypes.PURCHASE_ORDERS_AUTO.id, _vm.platformDocumentTypes.PURCHASE_ORDERS_ATTACHED.id].includes(item.type) ? [_vm._v(" P.Order #" + _vm._s(item.relativeParentId) + " ")] : [_vm.platformDocumentTypes.CREDIT_NOTES_AUTO.id, _vm.platformDocumentTypes.CREDIT_NOTES_ATTACHED.id].includes(item.type) ? [_vm._v(" C.Note #" + _vm._s(item.relativeParentId) + " ")] : [_vm.platformDocumentTypes.WINES_ATTACHED.id].includes(item.type) ? [_vm._v(" Product #" + _vm._s(item.relativeParentId) + " ")] : [_vm.platformDocumentTypes.WINERIES_ATTACHED.id].includes(item.type) ? [_vm._v(" Producer #" + _vm._s(item.relativeParentId) + " ")] : [_vm._v(" " + _vm._s(item.relativeParentId) + " ")]], 2)], 1) : _c("div", [_vm._v(" " + _vm._s(_vm.emptyCellContent) + " ")])];
      }
    }, {
      key: "item.creationDate",
      fn: function fn(_ref13) {
        var item = _ref13.item;
        return [item.creationDate ? _c("div", [_vm._v(" " + _vm._s(_vm._f("formatDate")(item.creationDate)) + " ")]) : _c("div", [_vm._v(" " + _vm._s(_vm.emptyCellContent) + " ")])];
      }
    }, {
      key: "item.absoluteAccessUri",
      fn: function fn(_ref14) {
        var item = _ref14.item;
        return [_c("div", {
          staticClass: "td-without-link --inline-actions",
          on: {
            click: function click($event) {
              $event.stopPropagation();
            }
          }
        }, [_c(VBtn, {
          staticClass: "dfwa-btn --small-2",
          on: {
            click: function click($event) {
              return _vm.documentDownload(item.absoluteAccessUri, item.filename);
            }
          }
        }, [_vm._v(" Download ")]), _c(VTooltip, {
          attrs: {
            top: ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref15) {
              var on = _ref15.on,
                attrs = _ref15.attrs;
              return [_c(VIcon, _vm._g(_vm._b({
                staticClass: "ml-2",
                attrs: {
                  size: "15"
                },
                on: {
                  click: function click($event) {
                    return _vm.documentCopyLink(item);
                  }
                }
              }, "v-icon", attrs, false), on), [_vm._v(" fas fa-share-alt ")])];
            }
          }], null, true)
        }, [!_vm.documents.isCopyingToClipboard ? _c("span", [_vm._v("Copy link to clipboard")]) : _vm._e(), _vm.documents.isCopyingToClipboard ? _c("div", [_c(VIcon, {
          staticStyle: {
            color: "green"
          }
        }, [_vm._v("mdi-check")]), _vm._v(" Copied ")], 1) : _vm._e()])], 1)];
      }
    }], null, true)
  })], 1)])])]) : _vm._e(), _vm.canManageWineryDashboards ? _c(VTabItem, {
    key: 6
  }, [_c("div", [_c("div", {
    staticClass: "mt-default"
  }, [_c("div", {
    staticClass: "container-centered small-2"
  }, [_c("div", {
    staticClass: "flex gap-3 items-center"
  }, [_c(VAutocomplete, {
    attrs: {
      disabled: _vm.producers.length <= 0,
      items: _vm.producers,
      "item-value": "id",
      "item-text": "name",
      label: _vm.producers.length > 0 ? "Producer" : "Loading...",
      "hide-details": "auto",
      clearable: ""
    },
    on: {
      change: function change($event) {
        _vm.wineryDashboards.formSearch.wineryId != _vm.wineryDashboards.lastSearch.wineryId && _vm.wineryDashboardsSearch();
      }
    },
    model: {
      value: _vm.wineryDashboards.formSearch.wineryId,
      callback: function callback($$v) {
        _vm.$set(_vm.wineryDashboards.formSearch, "wineryId", $$v);
      },
      expression: "wineryDashboards.formSearch.wineryId"
    }
  }), _c(VCheckbox, {
    staticStyle: {
      "margin-bottom": "-1rem !important",
      width: "fit-content"
    },
    attrs: {
      label: "Exclude inactive dashboards"
    },
    on: {
      change: function change($event) {
        return _vm.wineryDashboardsSearch();
      }
    },
    model: {
      value: _vm.wineryDashboards.formSearch.excludeInactive,
      callback: function callback($$v) {
        _vm.$set(_vm.wineryDashboards.formSearch, "excludeInactive", $$v);
      },
      expression: "wineryDashboards.formSearch.excludeInactive"
    }
  })], 1)]), _c("div", {
    staticClass: "mt-default"
  }, [_c("div", {
    staticClass: "container-centered small"
  }, [_c("div", {
    staticClass: "flex justify-end mb-2"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small-2",
    attrs: {
      rounded: "",
      disabled: _vm.wineryDashboards.isDataLoading
    },
    on: {
      click: function click($event) {
        return _vm.openAddWineryDashboard();
      }
    }
  }, [_c(VIcon, {
    staticClass: "mr-1",
    attrs: {
      size: "0.65rem"
    }
  }, [_vm._v("fa fa-plus")]), _vm._v(" Add new dashboard ")], 1)], 1), _vm.wineryDashboards.isDataLoading ? _c("div", {
    staticClass: "list-empty text-center text-italic"
  }, [_c("p", [_vm._v("Loading data ...")])]) : _vm.wineryDashboards.results.totalCount === null ? _c("div", {
    staticClass: "list-empty text-center text-italic"
  }, [_vm._v(" Please do a search to display the results table ")]) : _vm.wineryDashboards.results.totalCount === 0 ? _c("div", {
    staticClass: "list-empty text-center text-italic"
  }, [_vm._v(" No dashboard matchs these filters ")]) : _c(VDataTable, {
    staticClass: "cursor--pointer",
    attrs: {
      headers: _vm.wineryDashboards.results.headers,
      items: _vm.wineryDashboards.results.items,
      "items-per-page": +_vm.wineryDashboards.results.totalCount,
      "footer-props": {
        options: {
          itemsPerPage: -1
        }
      },
      "disable-sort": ""
    },
    on: {
      "click:row": _vm.wineryDashboardsRowClick
    },
    scopedSlots: _vm._u([{
      key: "item.wineries",
      fn: function fn(_ref16) {
        var item = _ref16.item;
        return [_vm._l(item.configuration.wineries.slice(0, 3), function (winery) {
          return _c("div", {
            key: "wineryDashboard-".concat(item.id, "-").concat(winery.id)
          }, [_vm._v(" " + _vm._s(winery.name) + " ")]);
        }), item.configuration.wineries.length > 3 ? _c("div", [_vm._v(" (..." + _vm._s(item.configuration.wineries.length - 3) + " more) ")]) : _vm._e()];
      }
    }, {
      key: "item.isShowTurnover",
      fn: function fn(_ref17) {
        var item = _ref17.item;
        return [_c("div", [item.configuration.isShowTurnover ? _c(VIcon, {
          attrs: {
            small: "",
            color: "green"
          }
        }, [_vm._v(" fa-check ")]) : _c("div", [_c(VIcon, {
          attrs: {
            small: "",
            color: "red"
          }
        }, [_vm._v("fa-times")])], 1)], 1)];
      }
    }, {
      key: "item.isActive",
      fn: function fn(_ref18) {
        var item = _ref18.item;
        return [_c("div", [item.isActive ? _c(VIcon, {
          attrs: {
            small: "",
            color: "green"
          }
        }, [_vm._v("fa-check")]) : _c("div", [_c(VIcon, {
          attrs: {
            small: "",
            color: "red"
          }
        }, [_vm._v("fa-times")])], 1)], 1)];
      }
    }, {
      key: "item.creationDate",
      fn: function fn(_ref19) {
        var item = _ref19.item;
        return [_c("div", {
          staticClass: "text-smaller"
        }, [_vm._v(" " + _vm._s(_vm._f("formatDate")(item.creationDate)) + " ")])];
      }
    }, {
      key: "item.actions",
      fn: function fn(_ref20) {
        var item = _ref20.item;
        return [_c("div", {
          staticClass: "td-without-link --inline-actions",
          on: {
            click: function click($event) {
              $event.stopPropagation();
            }
          }
        }, [_c(VTooltip, {
          attrs: {
            top: ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref21) {
              var on = _ref21.on,
                attrs = _ref21.attrs;
              return [_c("span", _vm._g(_vm._b({
                staticClass: "dfwa-btn --small-2 secondary cursor--pointer --rounded",
                on: {
                  click: function click($event) {
                    return _vm.wineryDashboardCopyLink(item);
                  }
                }
              }, "span", attrs, false), on), [_c(VIcon, {
                staticClass: "fas fa-share-alt mr-1",
                attrs: {
                  size: "0.65rem"
                }
              }), _vm._v(" Access url ")], 1)];
            }
          }], null, true)
        }, [!_vm.wineryDashboards.isCopyingToClipboard ? _c("span", [_vm._v(" Copy access url to clipboard ")]) : _vm._e(), _vm.wineryDashboards.isCopyingToClipboard ? _c("div", [_c(VIcon, {
          staticStyle: {
            color: "green"
          }
        }, [_vm._v("mdi-check")]), _vm._v(" Copied ")], 1) : _vm._e()]), _c(VBtn, {
          staticClass: "dfwa-btn --small-2 secondary cursor--pointer --rounded ml-2",
          attrs: {
            href: item.absoluteAccessUri,
            target: "_blank"
          }
        }, [_c(VIcon, {
          staticClass: "fas fa-eye mr-1",
          attrs: {
            size: "0.65rem"
          }
        }), _vm._v(" Open ")], 1)], 1)];
      }
    }], null, true)
  })], 1)])])]), _c("WineryDashboardFormModal", {
    ref: "wineryDashboardForm",
    attrs: {
      id: _vm.wineryDashboards.editedId
    },
    on: {
      dashboardUpdated: _vm.wineryDashboardsSearch,
      dashboardCreated: _vm.wineryDashboardsSearch,
      dashboardDeleted: _vm.wineryDashboardsSearch
    }
  })], 1) : _vm._e()], 1), _vm.showPaymentSearchDialog ? _c("PaymentSearchDialog", {
    ref: "paymentSearchDialog",
    attrs: {
      loggedUserData: _vm.loggedUserData
    },
    on: {
      closed: function closed($event) {
        _vm.showPaymentSearchDialog = false;
      }
    }
  }) : _vm._e(), _c("Confirm", {
    ref: "confirm"
  }), _c("ErrorModal", {
    ref: _vm.ERROR_DATA.ref
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };